<template>
  <div class="tab-page">
    <div class="type-wrapper">
      <span
        class="pr-20"
        :class="{ active: type === 'users' }"
        @click="selectType('users')"
        v-if="p('Manage.Users.View')"
      >
        {{ $t('text.users') }}
      </span>
      <span
        class="pr-20"
        :class="{ active: type === 'roles' }"
        @click="selectType('roles')"
        v-if="p('Manage.Roles.View')"
      >
        {{ $t('text.roles') }}
      </span>
    </div>
    <UserList v-if="type === 'users'" />
    <RoleList v-if="type === 'roles'" />
  </div>
</template>

<script>
import UserList from '@/components/manage/UserList'
import RoleList from '@/components/manage/RoleList'
export default {
  data() {
    return {
      type: 'users'
    }
  },
  components: {
    UserList,
    RoleList
  },
  mounted() {
    this.type = this.$permission('Manage.Users.View') ? 'users' : 'roles'
  },
  methods: {
    selectType(type) {
      this.type = type
    }
  }
}
</script>
